/* Ficha J3. Mejora progresiva: si el JS falla, el form envia normal y todo sigue visible. */
(function(){
function money(c){return '$'+Math.round(c/100).toLocaleString('es-CO');}

/* Cambiar el texto de un boton en seco deja ver dos palabras
   cruzandose. Un desenfoque corto las funde en una sola: el ojo lee
   una transformacion, no un reemplazo. */
function swapLabel(el,btn,text){
  if(!el)return;
  if(!btn||window.matchMedia('(prefers-reduced-motion: reduce)').matches){el.textContent=text;return;}
  btn.classList.add('is-swap');
  setTimeout(function(){el.textContent=text;btn.classList.remove('is-swap');},150);
}

function init(sid){
  var root=document.getElementById('pdp-'+sid);
  if(!root||root.dataset.ready)return;
  root.dataset.ready='1';
  var raw=document.getElementById('pv-'+sid);
  var vs=[];try{vs=JSON.parse(raw.textContent);}catch(e){return;}
  // Shopify no expone inventory_quantity en el JSON de variantes: viene aparte.
  var qty={};var qraw=document.getElementById('pq-'+sid);
  if(qraw){try{qty=JSON.parse(qraw.textContent);}catch(e){qty={};}}

  var form=document.getElementById('pf-'+sid);
  var vid=root.querySelector('[data-vid]');
  var priceEl=root.querySelector('[data-price]');
  var addiEl=root.querySelector('[data-addi]');
  var leftEl=root.querySelector('[data-left]');
  var errEl=root.querySelector('[data-err]');
  var addBtn=root.querySelector('[data-add]');
  var addTxt=root.querySelector('[data-addtxt]');
  var buyBtn=root.querySelector('[data-buy]');
  var groups=root.querySelectorAll('[data-opt]');
  var state=[];
  groups.forEach(function(g){var on=g.querySelector('[aria-checked="true"]');state.push(on?on.dataset.val:null);});
  if(addBtn&&addTxt)addBtn.dataset.on=addTxt.textContent;

  function find(){
    for(var i=0;i<vs.length;i++){
      var v=vs[i],ok=true;
      for(var k=0;k<state.length;k++){if(state[k]===null||v.options[k]!==state[k]){ok=false;break;}}
      if(ok)return v;
    }
    return null;
  }

  function paint(){
    var v=find();
    if(!v){if(vid)vid.value='';if(addBtn)addBtn.disabled=true;if(leftEl)leftEl.textContent='';return;}
    if(vid)vid.value=v.id;
    if(priceEl)priceEl.textContent=money(v.price);
    if(addiEl){var t=addiEl.getAttribute('data-addi')||'';addiEl.textContent=t.replace('[CUOTA]',money(v.price/4));}
    if(addBtn)addBtn.disabled=!v.available;
    swapLabel(addTxt,addBtn,v.available?(addBtn&&addBtn.dataset.on||'Agregar al carrito'):'Agotado');
    if(buyBtn)buyBtn.disabled=!v.available;
    if(leftEl){
      var q=qty[String(v.id)];
      leftEl.textContent=(v.available&&typeof q==='number'&&q>0&&q<=5)?('Quedan '+q+' en esta talla'):'';
    }
    if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}
    if(errEl)errEl.classList.remove('is-on');
  }

  groups.forEach(function(g){
    var pos=parseInt(g.dataset.opt,10);
    g.querySelectorAll('.p-size').forEach(function(b){
      b.addEventListener('click',function(){
        if(b.disabled)return;
        state[pos]=b.dataset.val;
        g.querySelectorAll('.p-size').forEach(function(x){x.setAttribute('aria-checked','false');});
        b.setAttribute('aria-checked','true');
        paint();
      });
    });
  });

  function needSize(){
    for(var i=0;i<state.length;i++){if(state[i]===null)return true;}
    return false;
  }

  function post(then){
    var fd=new FormData(form);
    return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json();}).then(then);
  }

  if(form){
    form.addEventListener('submit',function(e){
      if(needSize()){e.preventDefault();if(errEl)errEl.classList.add('is-on');var f=root.querySelector('.p-size:not(:disabled)');if(f)f.focus();return;}
      if(!window.fetch)return;
      e.preventDefault();
      var old=addTxt?addTxt.textContent:'';
      swapLabel(addTxt,addBtn,'Agregando...');
      if(addBtn)addBtn.disabled=true;
      post(function(){
        swapLabel(addTxt,addBtn,'Agregado');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function(){swapLabel(addTxt,addBtn,old);if(addBtn)addBtn.disabled=false;},1800);
      }).catch(function(){
        swapLabel(addTxt,addBtn,old);
        if(addBtn)addBtn.disabled=false;
        form.submit();
      });
    });
  }

  if(buyBtn){
    buyBtn.addEventListener('click',function(){
      if(needSize()){if(errEl)errEl.classList.add('is-on');return;}
      buyBtn.disabled=true;
      post(function(){location.href='/checkout';}).catch(function(){buyBtn.disabled=false;});
    });
  }

  var stage=root.querySelector('[data-stage]');
  if(stage){
    var slides=stage.querySelectorAll('[data-slide]');
    root.querySelectorAll('[data-th]').forEach(function(th){
      th.addEventListener('click',function(){
        var k=th.dataset.th;
        slides.forEach(function(s){s.classList.toggle('is-on',s.dataset.slide===k);});
        root.querySelectorAll('[data-th]').forEach(function(x){x.setAttribute('aria-current',x===th?'true':'false');});
      });
    });
  }

  var guide=root.querySelector('[data-guide]');
  if(guide){
    guide.addEventListener('click',function(){
      var accs=root.querySelectorAll('.p-acc details');
      for(var i=0;i<accs.length;i++){
        var s=accs[i].querySelector('summary');
        if(s&&/talla/i.test(s.textContent)){accs[i].open=true;accs[i].scrollIntoView({block:'center'});return;}
      }
    });
  }

  if('IntersectionObserver' in window){
    var gal=root.querySelector('[data-gal]'),info=root.querySelector('[data-info]');
    if(gal&&info){
      root.classList.add('j3-anim');
      var seen=0;
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');seen++;io.unobserve(e.target);}});
      },{threshold:.05});
      io.observe(gal);io.observe(info);
      setTimeout(function(){if(seen<2)root.classList.remove('j3-anim');},2000);
    }
  }
}

function boot(){
  var q=window.J3PDP||[];
  if(q&&q.length)for(var i=0;i<q.length;i++)init(q[i]);
  window.J3PDP={push:init,length:0};
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
document.addEventListener('shopify:section:load',boot);
})();
